import { useState } from "react";
import { FaUserPlus, FaPeopleArrows, FaHouse, FaHandshakeAngle } from "react-icons/fa6";
import { Grid } from "@mui/material";
import Templete from "../../template/Template";
import ButtonCard from "../../components/ButtonCard/ButonCard";
import ModalDocumentoAvulso from "./ModalDocumentoAvulso";

export default function DocumentosAvulsos() {
    const [openModal, setOpenModal] = useState(false);
    const [indexModal, setIndexModal] = useState(0);

    function handleModal(ind: number) {
        setIndexModal(ind);
        setOpenModal(true);
    }

    return (
        <Templete menuActive="documentosavulsos">
            <ModalDocumentoAvulso
                open={openModal}
                setOpen={setOpenModal}
                index={indexModal}
            />

            <Grid container spacing={1}>
                <Grid item xs={12} sm={3}>
                    <ButtonCard
                        icon={<FaUserPlus size={55} />}
                        title="DECLARAÇÃO DE UNIÃO ESTÁVEL"
                        handle={() => handleModal(0)}
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <ButtonCard
                        icon={<FaPeopleArrows size={55} />}
                        title="DECLARAÇÃO DE SEPARAÇÃO"
                        handle={() => handleModal(1)}
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <ButtonCard
                        icon={<FaHouse size={55} />}
                        title="DECLARAÇÃO DE RESIDÊNCIA"
                        handle={() => handleModal(2)}
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <ButtonCard
                        icon={<FaHandshakeAngle size={55} />}
                        title="CONTRATO DE PARCERIA RURAL"
                        handle={() => handleModal(3)}
                    />
                </Grid>
            </Grid>
        </Templete>
    );
}